export default __webpack_public_path__ + "static/media/black-logo.0ad3c0bc.svg";